import React, { useEffect, useState } from 'react'
import { ModalPopUp } from '../../Components/ModalPopUp/ModalPopUp'
import LocalLoader from '../../Components/Loader/LocalLoader';
import { TableWrapper } from '../../Components/styledConstant';
import { getAnalyseDetails } from '../../utils/api';
import { CSVLink } from 'react-csv';

const csvHeader = [
  { label: "Terminal ID", key: "terminalId" },
  { label: "Total Amount (₹)", key: "totalAmount" },
  { label: "Calculated Settlement (₹)", key: "calSettlement" },
  { label: "Final Settlement (₹)", key: "finalSettlement" },
  { label: "Difference (₹)", key: "difference" },
];

const formatAmount = (val) => {
  if (val === null || val === undefined) return "-";

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};


function AnalyseDetails({data,onClose}) {
    const [list, setList] = useState([]);
      const [loading, setLoading] = useState(false);


      const getList = async () => {
      
              setLoading(true);
              getAnalyseDetails(data?.processId).then((resp) => {
                  setLoading(false);
      
                  if (resp?.data?.success) {
                      setList(resp?.data?.data);
                   
                  }
              });
          };

        useEffect(()=>{
            if(data?.processId)
            getList()
        },[data]);

  return (
     <ModalPopUp
    
     >
              <div
                className="modal-popup"
                
                style={{
                //   backgroundImage: `url(${modalpopup})`,
                //   backgroundRepeat: "no-repeat",
                //   backgroundPositionX: "right",
                //   backgroundPositionY: "bottom",
                width:"calc(100% - 40px)",
                maxHeight:"100%",
                maxWidth:"800px",
                overflow:"auto",
              
                }}
              >
                <div>
                  
                </div>
              
                <div
                  className="flex justify-center mr-20"
                  style={{ color: "#8B9CA8" }}
                  onClick={onClose}
                >
                  <i
                    className="fa-solid fa-xmark"
                    style={{
                      display: "inline-block",
                      maxWidth: "40px",
                      marginLeft: " auto",
                      fontSize: "25px",
                    }}
                  ></i>
                </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:"20px", marginTop:"10px"}}>
                      <h2 style={{fontSize:"20px"}}>Analyse Report Details</h2>
                      <CSVLink
              
                  data={list}
                  headers={csvHeader}
                  filename={`Analyse_Report_Details_${data?.processId}.csv`}
                >
                      <button className='userlist_btn'>
                        <i class="fa-solid fa-download"></i> CSV
                      </button>
                </CSVLink>
                  </div>
               <div>
                  <div className="table-loader">
                    {loading && <LocalLoader className="tableLoader" />}
                    <TableWrapper className="table-card-wrapper">
                        <table className="table custom-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "60px" }}>S.No</th>
                                    <th>Terminal ID</th>
                                    <th>Total Amount</th>
                                    <th>Calculated Settlement</th>
                                    <th>Final Settlement</th>
                                    <th>Difference</th>
                            
                                </tr>
                            </thead>

                            <tbody>
                                {list?.map((item, i) => (
                                    <tr key={item.terminalId}>
                                        <td>{i + 1}</td>

                                        <td className="text-ellipsis">{item?.terminalId}</td>

                                        <td>{formatAmount(item?.totalAmount)}</td>
                                        <td>{formatAmount(item?.calSettlement)}</td>
                                        <td>{formatAmount(item?.finalSettlement)}</td>
                                        <td>{formatAmount(item?.difference)}</td>

                                      

                                         
                                     
                                    </tr>
                                ))}

                                {!loading && list.length < 1 && (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
               </div>
              </div>
            </ModalPopUp>
  )
}

export default AnalyseDetails